/**
 * The assembler stage's `data-handle` protocol, routed into the headless
 * gesture engine: `aroom:<id>` is a room's body (click selects, drag moves),
 * `aroom-rotate:<id>` its rotation handle. Anything else deselects.
 */
import type { Point } from '@kaiizen/kai-floor-plan';
import { type AssemblerMutableState, beginRoomMove, beginRoomRotate, selectAssemblyRoom } from '@kaiizen/kai-floor-plan-editor-core';

export const roomHandle = (id: string): string => `aroom:${id}`;
export const roomRotateHandle = (id: string): string => `aroom-rotate:${id}`;

/** Apply a pointer-down on `handle` (null = empty stage) at plan point `model`. */
export function assemblyPointerDown(st: AssemblerMutableState, handle: string | null, model: Point): void {
  st.editingKey = null;
  if (!handle) {
    selectAssemblyRoom(st, { kind: 'none' });
    return;
  }
  const separator = handle.indexOf(':');
  const type = separator < 0 ? handle : handle.slice(0, separator);
  const id = separator < 0 ? '' : handle.slice(separator + 1);
  if (type === 'aroom') beginRoomMove(st, id, model);
  else if (type === 'aroom-rotate') beginRoomRotate(st, id);
  else selectAssemblyRoom(st, { kind: 'none' });
}
